import React from "react";
import PeopleIcon from '@mui/icons-material/People';
import GroupsIcon from '@mui/icons-material/Groups';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

function Achievement() {
  return (
    <div className="mt-20">
      <h1 className="text-black text-3xl font-bold text-center">Achievement</h1>
      <div className="bg-blue-400 w-full lg:h-[350px] h-[600px] flex flex-wrap justify-around items-center p-10 mt-10">
        <div className="flex flex-row items-center gap-3"> {/* Changed to flex-row */}
          <PeopleIcon style={{fontSize:'90px', color:"white"}}/>
          <h1 className="text-white font-bold text-3xl">10-20</h1>
          <h3 className="text-white text-2xl">Our Staff</h3>
        </div>
        <div className="flex flex-row items-center gap-3"> {/* Changed to flex-row */}
          <GroupsIcon style={{fontSize:'90px', color:"white"}}/>
          <h1 className="text-white font-bold text-3xl">20 +</h1>
          <h3 className="text-white text-2xl">Our Clients</h3>
        </div>
        <div className="flex flex-row items-center gap-3"> {/* Changed to flex-row */}
          <DoneOutlineIcon style={{fontSize:'90px', color:"white"}}/>
          <h1 className="text-white font-bold text-3xl">50</h1>
          <h3 className="text-white text-2xl">Completed Projects</h3>
        </div>
        <div className="flex flex-row items-center gap-3"> {/* Changed to flex-row */}
          <TrendingUpIcon style={{fontSize:'90px', color:"white"}}/>
          <h1 className="text-white font-bold text-3xl">10</h1>
          <h3 className="text-white text-2xl">Running Projects</h3>
        </div>
      </div>
    </div>
  );
}

export default Achievement;